import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './app/App'
import { AppErrorBoundary } from './app/AppErrorBoundary'
import './styles/index.css'
import './styles/brand.css'
import './styles/brand-assets.css'
import './styles/brand-final.css'
import './styles/discovery.css'
import './styles/discovery-participation.css'
import './styles/candidate-review.css'
import './styles/portfolio.css'
import './styles/strategy-studio.css'
import './styles/register.css'
import './styles/ai-use-disclosure.css'
import './styles/r1-disclosure-card-guard.css'
import './styles/service-access.css'
import './styles/product-experience.css'
import './styles/product-experience-support.css'
import './styles/motion.css'
import './styles/surface-consistency.css'
import './styles/onboarding-phase2.css'
import './styles/onboarding-phase2-refinement.css'
import './styles/system-discovery.css'
import './styles/governance.css'
import './styles/governance-visual-refinement.css'
import './styles/governance-interaction.css'
import './styles/r1-ai-use-record-completion.css'
import './styles/risk.css'
import './styles/risk-config.css'
import './styles/reporting.css'
import './styles/approved-ui.css'
import './styles/action-language.css'
import './styles/visual-polish.css'
import './styles/changes-incidents.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
})

const root = document.getElementById('root')

if (!root) throw new Error('Application root element was not found.')

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>,
)
